export default __webpack_public_path__ + "static/media/hero-level-6-bg.f09ac9cf.webp";